<template id="carltest">  
	<!--<v-app id="inspire">-->
      <v-app :id="getManu()">
        <div id="app">                   
          <router-view />
        </div>
      </v-app>
</template>

<script>
  import Vue from 'vue';
  import { mapGetters } from 'vuex';
	
	export default {
		data () {
			return {
              cordova: Vue.cordova              
			}
		},
		created () {
			var self = this;
			this.cordova.on('deviceready', () => {
				self.onDeviceReady()
			})
		},
		methods: {
			onDeviceReady: function () {       
				this.cordova.on('pause', this.onPause, false);
				this.cordova.on('resume', this.onResume, false);
				if (this.cordova.device.platform === 'Android') {
					document.addEventListener('backbutton', this.onBackKeyDown, false);
				}
			},
			onBackKeyDown () {
				navigator.app.exitApp();
            },
            getManu() {
              return 'manu_'+this.objAuthorize.manufacturer;
            }
        },
        computed: {
          ...mapGetters([
            'objAuthorize'            
          ])
        }
	}
</script>

<style>

</style>
